import { IV3D } from '@/Interfaces/v3d';
import { lineDiameter, lineSegmentLength } from '@/Constants/3dConfig';
import { Material } from 'three';

declare let v3d: IV3D;

const lineMaterial = new v3d.MeshStandardMaterial({ color: 0x393349 });
const  lineBlackMaterial = new v3d.MeshStandardMaterial({ color: 0x000000 });

const geometry = new v3d.BoxGeometry(1, 1, 1, 6);

export function getLineMesh(black = false) {
    const line  = new v3d.Mesh(geometry, black ? lineBlackMaterial : lineMaterial);
    line.rotation.x = Math.PI / 2;
    line.scale.set(lineDiameter / 2, lineSegmentLength, lineDiameter / 2);
    return line;
}
